import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../assets/logo/Airdrie-Samaj-Logo-png.png";
import navbarBg from "../assets/Footer/shutterstock_2506871797.jpg";
import { FaBars, FaTimes } from "react-icons/fa";
//import AuthDropdown from "./AuthDropdown";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Events", path: "/events" },
    { name: "Membership Info", path: "/membershipinfo" },
    { name: "Contact Us", path: "/contact" },
  ];

  useEffect(() => {
    const loadUser = () => {
      const storedUser = localStorage.getItem("member");
      setUser(storedUser ? JSON.parse(storedUser) : null);
    };

    loadUser();

    window.addEventListener("storage", loadUser);
    window.addEventListener("authChanged", loadUser);

    return () => {
      window.removeEventListener("storage", loadUser);
      window.removeEventListener("authChanged", loadUser);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("member");
    window.dispatchEvent(new Event("authChanged"));
    setUser(null);
    navigate("/");
  };

  return (
    <header
      className="sticky top-0 z-50 shadow-md backdrop-blur-md"
      style={{
        backgroundImage: `url(${navbarBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-brand-saffron/80 to-brand-mint/80"></div>

      <div className="relative max-w-7xl mx-auto px-4 py-3 flex justify-between items-center z-10">
        
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="Logo"
            className="h-[80px] hover:scale-105 transition"
          />
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center gap-4">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="px-3 py-1 rounded-md font-medium text-gray-900 hover:text-white hover:bg-black/20 transition"
            >
              {item.name}
            </Link>
          ))}

          {/* User Section */}
          <div className="flex items-center gap-3 ml-2">
            {user && (
              <span className="text-sm font-medium text-gray-900 hidden lg:block">
                Hi, {user.full_name || user.email}
              </span>
            )}

            {/* <AuthDropdown
              user={user}
              setUser={setUser}
              onLogout={handleLogout}
            /> */ }
          </div>
        </nav>

        {/* Mobile */}
        <div className="md:hidden flex items-center gap-3">
          { /*<AuthDropdown
            user={user}
            setUser={setUser}
            onLogout={handleLogout}
            mobile
          /> */}

          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white/95 px-6 py-4 space-y-3 shadow-lg">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className="block py-2 text-gray-800 hover:bg-gray-200 rounded"
            >
              {item.name}
            </Link>
          ))}

          {user && (
            <p className="text-sm text-center text-gray-600">
              Logged in as {user.full_name || user.email}
            </p>
          )}
        </div>
      )}
    </header>
  );
}